import { Link, useNavigate } from "react-router-dom";
import dataSourceIcon from "../../../assets/images/data-source-icon.svg";
import AviationStack from "../../../components/element/AviationStack";
import ROUTE_PATHS from "../../../utils/routePaths";
import "../../../components/css/AviationStack.css";
import "./DataSource.css";
import CommercialAirlineNavigationBar from "../../../components/element/CommercialAirlineNavigationBar";

const DataSource = () => {
  const navigate = useNavigate();

  const handleAviationClick = (status) => {
    if (status === "Failure") {
      navigate(
        ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE_AVIATION_STACK_FAILURE
      );
    } else if (status === "Success") {
      navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE_AIRLINES);
    }
  };

  return (
    <div className="data-source-container">
      <CommercialAirlineNavigationBar
        title={"Data Source"}
        navigationLogo={dataSourceIcon}
        backContent={
          <div className="navigation-header">
            <Link
              to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
              className="navigation-header-link"
            >
              Home/
            </Link>
            Data Source
          </div>
        }
      />
      <div className="data-source-content">
        <div className="data-source-status-row">
          <AviationStack
            status="Failure"
            onClick={() => handleAviationClick("Failure")}
          />
          <AviationStack
            status="Success"
            onClick={() => handleAviationClick("Success")}
          />
        </div>
      </div>
    </div>
  );
};

export default DataSource;
